import Dispatcher from '../dispatcher';
import { translateFromType, translateToType, TBS_TRANSLATE, TBB_TRANSLATE } from '../helper/configurator_name_translator';
import resolvePromise from '../helper/resolved_promise';
import configuratorRequestTyre from '../helper/requests/configurator_request_tyre';
import {Filters} from "../constants/filter/filters";
import ConfiguratorStoreClass from '../stores/tyre_by_size_store';

const TBS_TYPES = [
    'usage',
    'width',
    'height',
    'diameter',
];
let TBS_ORDER = [
    Filters.USAGE,
    Filters.WIDTH,
    Filters.HEIGHT,
    Filters.DIAMETER,
];
const TBB_TYPES = [
    'manufacturer',
    'profile_text',
];

const configuratorFilterValues = ConfiguratorStoreClass.getState();

const ConfiguratorActions = {
    updateUsageAction(payload) {
        Dispatcher.handleConfiguratorAction({
            type: 'UPDATE_USAGE',
            payload,
        });

        return resolvePromise();
    },
    updateWidthAction(payload) {
        Dispatcher.handleConfiguratorAction({
            type: 'UPDATE_WIDTH',
            payload,
        });

        return resolvePromise();
    },
    updateProfileAction(payload) {
        Dispatcher.handleConfiguratorAction({
            type: 'UPDATE_PROFILE',
            payload,
        });

        return resolvePromise();
    },
    updateRimAction(payload) {
        Dispatcher.handleConfiguratorAction({
            type: 'UPDATE_RIM',
            payload,
        });

        return resolvePromise();
    },
    updateBrandAction(payload) {
        Dispatcher.handleConfiguratorAction({
            type: 'UPDATE_BRAND',
            payload,
        });

        return resolvePromise();
    },
    updateModelAction(payload) {
        Dispatcher.handleConfiguratorAction({
            type: 'UPDATE_MODEL',
            payload,
        });

        return resolvePromise();
    },
    updateTbsOptionsAction(changedOptionType, changedOptionValue) {
        let fieldsToLoad = [];
        let selectedFilterValues = [];
        if (false === TYROOLA.globals.configuratorUsageEnabled) {
            const filterIndex = TBS_ORDER.indexOf(Filters.USAGE);
            if (filterIndex !== -1) {
                TBS_ORDER.splice(filterIndex, 1);
            }
        }

        const filter = translateFromType(changedOptionType, TBS_TRANSLATE);
        const changedIndexInCheckOrder = TBS_ORDER.indexOf(filter);
        if (changedIndexInCheckOrder === TBS_ORDER.length - 1) {
            return;
        }

        for (let i = 0; i <= changedIndexInCheckOrder; i++) {
            let tmp = translateToType(TBS_ORDER[i], TBS_TRANSLATE);
            selectedFilterValues[TBS_ORDER[i]] = configuratorFilterValues[tmp];
        }

        if (changedIndexInCheckOrder < TBS_ORDER.length) {
            for (let i = changedIndexInCheckOrder + 1; i < TBS_ORDER.length; ++i) {
                fieldsToLoad.push(TBS_ORDER[i]);
            }
        }

        return this._loadOptions(
                selectedFilterValues,
                fieldsToLoad,
                TBS_TRANSLATE
            )
            .done((response) => {
                this._updateOptions(response, fieldsToLoad, TBS_TRANSLATE);
            })
            .catch(() => {
                Dispatcher.handleConfiguratorAction({
                    type: 'OPTIONS_LOADING_ERROR_TBS',
                });
            });
    },
    updateTbbOptionsAction(changedOptionType, changedOptionValue) {
        const filterKey = translateFromType(changedOptionType, TBB_TRANSLATE);
        const fieldsToLoad = TBB_TYPES.filter(type => type !== filterKey);
        let filters = [];
        filters[filterKey] = changedOptionValue;
        return this._loadOptions(
            filters,
            fieldsToLoad,
            TBB_TRANSLATE,
        )
            .done((response) => {
                this._updateOptions(response, fieldsToLoad, TBB_TRANSLATE);
            })
            .catch(() => {
                Dispatcher.handleConfiguratorAction({
                    type: 'OPTIONS_LOADING_ERROR_TBB',
                });
            });
    },
    setInitialTbsOptionsAction(initialOptions) {
        return this._updateOptions(initialOptions, TBS_TYPES, TBS_TRANSLATE);
    },
    setInitialTbbOptionsAction(initialOptions) {
        return this._updateOptions(initialOptions, TBB_TYPES, TBB_TRANSLATE);
    },
    userInteractedWithConfiguratorAction() {
        Dispatcher.handleConfiguratorAction({
            type: 'UPDATE_FIRST_USER_INTERACTION',
        });

        return resolvePromise();
    },
    updatePostcodeAction(payload) {
        Dispatcher.handleConfiguratorAction({
            type: 'UPDATE_POSTCODE',
            payload,
        });

        return resolvePromise();
    },
    _updateOptions(options, loadedTypes, configuratorType) {
        if (configuratorType === TBS_TRANSLATE) {
            loadedTypes.forEach(type => {
                if (!options[type]) {
                    options[type] = [];
                }
            });
        }
        Dispatcher.handleConfiguratorAction({
            type: configuratorType === TBS_TRANSLATE ? 'UPDATE_TBS_OPTIONS' : 'UPDATE_TBB_OPTIONS',
            payload: options,
        });

        return resolvePromise();
    },
    _loadOptions(filters, fieldsToLoad, configuratorType) {
        Dispatcher.handleConfiguratorAction({
            type: configuratorType === TBS_TRANSLATE ? 'LOADING_START_TBS' : 'LOADING_START_TBB',
        });

        return configuratorRequestTyre(filters, fieldsToLoad);
    },
};

export default ConfiguratorActions;
